// extracted by mini-css-extract-plugin
export default {"header":"SectionTitle_header__M3XgR"};